import { action } from "typesafe-actions";

import { message } from "antd";

import { Gate, GatesActionTypes } from "./types";

export const gatesFetchRequest = () => action(GatesActionTypes.FETCH_REQUEST);

export const gatesFetchSuccess = (payload: { items: Gate[] }) => action(GatesActionTypes.FETCH_SUCCESS, payload);

export const loginAsUser = (gateId: number) => action(GatesActionTypes.LOGIN_AS_USER, gateId);

export const gatesFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(GatesActionTypes.FETCH_ERROR);
};

export const selectGate = (payload: { gateId: number }) => action(GatesActionTypes.SELECT, payload);
